import PropTypes from 'prop-types';
import React from 'react';
import ClientApplicationList from '~/components/ClientApplication/ClientApplicationList';
import NavigationSidebar from '~/components/NavigationSidebar';
import BaseLayout from '~/layouts/BaseLayout';

class ClientApplicationListLayout extends BaseLayout {
  static propTypes = {
    dispatch: PropTypes.func
  };

  renderSidebar() {
    return <NavigationSidebar />;
  }

  renderMain() {
    const { route } = this.props;

    return <ClientApplicationList route={route} />;
  }
}

export default ClientApplicationListLayout;
